import React from 'react';
import { RiChatSettingsLine, RiChatDeleteLine, RiArrowUpLine, RiTimerLine, RiCheckDoubleLine } from 'react-icons/ri';
import { Divider } from 'antd';
import { Permissions } from '@whatsper/texterchat-common';
import Collapsable from './Collapsable';
import { useStore } from '../../../../store/rootStore';
import s from './Collapsable/Collapsable.module.scss';
const ChatSettings = ({ goToAppPath }) => {
    const { agentsStore, checkFeatureAvailability } = useStore();
    const allRoutes = [
        {
            titleKey: 'exportChats',
            icon: React.createElement(RiArrowUpLine, null),
            path: '/manage/chats/export',
            requiredPermissions: [Permissions.Permission.export_list],
        },
        {
            titleKey: 'resolvePendingChats',
            icon: React.createElement(RiCheckDoubleLine, null),
            path: '/manage/chats/resolve-pending',
            requiredPermissions: [Permissions.Permission.chats_bulk_resolve],
        },
        {
            titleKey: 'autoResolveChats',
            icon: React.createElement(RiTimerLine, null),
            path: '/manage/chats/auto-resolve',
            requiredPermissions: [Permissions.Permission.automations_manage],
            requiredFeature: 'autoResolveChatsAutomation',
        },
        {
            titleKey: 'autoDeleteSettings',
            icon: React.createElement(RiChatDeleteLine, null),
            path: '/manage/chats/auto-delete',
            requiredPermissions: [Permissions.Permission.scheduled_deletion_manage],
        },
    ];
    const routes = allRoutes.filter(route => (!route.requiredPermissions || agentsStore.hasPermissions(route.requiredPermissions))
        && (!route.requiredFeature || checkFeatureAvailability(route.requiredFeature)));
    if (routes.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, { className: s.divider }),
        React.createElement(Collapsable, { title: "chatSettings", icon: React.createElement(RiChatSettingsLine, null), routes: routes, goToAppPath: goToAppPath })));
};
export default ChatSettings;
